import { Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/ui-bits";

const pill = {
  applied: "bg-emerald-100 text-emerald-800",
  discarded: "bg-stone-200 text-stone-700",
  open: "bg-amber-100 text-amber-800",
  applying: "bg-blue-100 text-blue-800",
};

export default function StockTakeHistory({ sessions, onReprint }) {
  if (!sessions.length) return null;
  return (
    <Panel title="Previous stock takes">
      <div className="divide-y divide-border" data-testid="stocktake-history">
        {sessions.map((s) => (
          <div key={s.id} className="py-2.5 flex flex-wrap items-center gap-3 text-sm" data-testid={`stocktake-session-${s.id}`}>
            <span className={`pill-stage text-xs ${pill[s.status] || ""}`}>{s.status}</span>
            <div className="flex-1 min-w-0">
              Started {s.created_at?.slice(0, 16).replace("T", " ")} by {s.created_by_name}
              {s.status === "applied" && (
                <span className="text-stone-500"> · switched {s.applied_at?.slice(0, 16).replace("T", " ")} by {s.applied_by_name} · {s.applied_rows_created} new / {s.applied_rows_wiped} zeroed</span>
              )}
            </div>
            {s.status === "applied" && (
              <Button variant="outline" size="sm" className="h-10 gap-1.5" onClick={() => onReprint(s)} data-testid={`stocktake-reprint-${s.id}`}>
                <Printer className="h-4 w-4" /> Labels
              </Button>
            )}
          </div>
        ))}
      </div>
    </Panel>
  );
}
